import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { EMPTY, from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
    deleteEndDateForDatesIntervalEditor,
    ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR,
    OnDeleteEndDateForDatesIntervalEditor
} from '../../actions/datesIntervalEditor';
import { confirm } from '../../service/Confirm/Confirm';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

import * as keyset from './datesIntervalEditor.i18n';
const i18n = i18nFactory(keyset);

export const onDeleteEndDateForDatesIntervalEditorEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR),
        mergeMap(
            (
                action: OnDeleteEndDateForDatesIntervalEditor
            ): Observable<Action> => {
                const { showMessage, onRemoveEndDate } = action;

                if (!showMessage) {
                    if (onRemoveEndDate) {
                        onRemoveEndDate();
                    }

                    return of(
                        deleteEndDateForDatesIntervalEditor(action.editorId)
                    );
                }

                return from(
                    confirm({
                        message: i18n('clear-end-date-confirm-text')
                    })
                ).pipe(
                    mergeMap(
                        (): Observable<Action> => {
                            if (onRemoveEndDate) {
                                onRemoveEndDate();
                            }

                            return of(
                                deleteEndDateForDatesIntervalEditor(
                                    action.editorId
                                )
                            );
                        }
                    ),
                    catchError((): Observable<Action> => EMPTY)
                );
            }
        )
    );
};
